import { Controller, useFormContext } from "react-hook-form";
import VerificationInput from "react-verification-input";

interface PropsInterface {
  name: string;
  label: string;
  rules?: any;
  [x: string]: any;
}

export const InputFormMaskPin = ({
  name,
  label,
  rules,
  ...props
}: PropsInterface) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <VerificationInput onChange={onChange} value={value || ""} {...props} />
      )}
      rules={rules}
    />
  );
};
